import * as D from '../../deps';
import * as BranchioWorkers from '../workers';

export default [
  {
    actionType: [
      D.Constants.Api.ApiActions.ANON_LOGIN_SUCCESS,
      D.Constants.Api.ApiActions.LOGIN_SUCCESS,
    ],
    handler: BranchioWorkers.onLoginSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.LOGOUT_SUCCESS,
    handler: BranchioWorkers.onLogoutSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.REGISTER_SUCCESS,
    handler: BranchioWorkers.onRegisterSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Payments.Actions.ACQUIRE_OFFER_SUCCESS,
    handler: BranchioWorkers.onAcquireOfferSuccess,
    concur: 'takeOnly',
  },
];
